export enum DrawingTypeEnum {
    General = 'generalDrawing',
    Monolith = 'monolith',
    Laying = 'laying',
    Foundation = 'foundation',
    PileField = 'pileField',
}
